
// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// import axiosInstance from "../../../axiosinterceptor";
// import pako from "pako";
// import { saveCodebookToIndexedDB,getCodebookFromIndexedDB} from "../../../utils/indexedDB";


// const decompressData = (data) => {
//   if (data?.body) {
//     try {
//       const decompressedBody = pako.ungzip(
//         Uint8Array.from(atob(data.body), (c) => c.charCodeAt(0)),
//         { to: "string" }
//       );
//       return JSON.parse(decompressedBody);
//     } catch (error) {
//       console.error("Error decompressing data:", error);
//       return null;
//     }
//   }
//   return null;
// };

// const initialState = {
//   // 12th Edition
//   icd10amTabularData: [],
//   icd10amIndexData: [],
//   achiIndexData: [],
//   achiTabularData: [],
//   pcsIndexData: [],
//   pcsTabularData: [],

//   // 13th Edition
//   icd10amTabularData13: [],
//   icd10amIndexData13: [],
//   achiIndexData13: [],
//   achiTabularData13: [],

//   codeBookLoading: false,
//   codeBookError: {},
//   acsCode: "",
//   isFetched12: false,
//   isFetched13: false,
// };

// export const fetchCodebookData = createAsyncThunk(
//   "codebook/fetchData12",
//   async (_, { dispatch }) => {
//     dispatch(fetchCodebookDataPending());

//     // Try from cache
//     const cachedData = await getCodebookFromIndexedDB("codebookData12");
//         console.log("[IndexedDB] Checking cache for 'codebookData12'...");

//     if (cachedData) {
//       console.log("[IndexedDB] Cache hit for 'codebookData12'. Using cached data.");

//       dispatch(fetchCodebookDataUpdate({ type: "icd10amTabularData", data: cachedData.icd10amTabularData }));
//       dispatch(fetchCodebookDataUpdate({ type: "icd10amIndexData", data: cachedData.icd10amIndexData }));
//       dispatch(fetchCodebookDataUpdate({ type: "achiIndexData", data: cachedData.achiIndexData }));
//       dispatch(fetchCodebookDataUpdate({ type: "achiTabularData", data: cachedData.achiTabularData }));
//       dispatch(fetchCodebookDataUpdate({ type: "pcsIndexData", data: cachedData.pcsIndexData }));
//       dispatch(fetchCodebookDataUpdate({ type: "pcsTabularData", data: cachedData.pcsTabularData }));

//       // Set flag in localStorage
//       localStorage.setItem("isFetched12", "true");
//       return;
//     }
//         console.log("[IndexedDB] No cache found. Fetching data from API...");

//     let icd10amTabularRes, icd10amIndexRes, achiIndexRes, achiTabularRes, pcsIndexRes, pcsTabularRes;

//     try {
//       icd10amTabularRes = await axiosInstance.get("/codebook_acs");
//       dispatch(fetchCodebookDataUpdate({ type: 'icd10amTabularData', data: decompressData(icd10amTabularRes.data) }));
//     } catch (err) {
//       dispatch(fetchCodebookDataError({ type: 'icd10amTabularData', error: err.message || "Failed to fetch ICD10AM Tabular" }));
//     }

//     try {
//       icd10amIndexRes = await axiosInstance.get("/index_codebook_acs");
//       dispatch(fetchCodebookDataUpdate({ type: "icd10amIndexData", data: decompressData(icd10amIndexRes.data) }));
//     } catch (err) {
//       dispatch(fetchCodebookDataError({ type: "icd10amIndexData", error: err.message }));
//     }

//     try {
//       achiIndexRes = await axiosInstance.get("/AchiCodebookIndex");
//       dispatch(fetchCodebookDataUpdate({ type: "achiIndexData", data: decompressData(achiIndexRes.data) }));
//     } catch (err) {
//       dispatch(fetchCodebookDataError({ type: "achiIndexData", error: err.message }));
//     }

//     try {
//       achiTabularRes = await axiosInstance.get("/achi_codebook_tabular");
//       dispatch(fetchCodebookDataUpdate({ type: "achiTabularData", data: decompressData(achiTabularRes.data) }));
//     } catch (err) {
//       dispatch(fetchCodebookDataError({ type: "achiTabularData", error: err.message }));
//     }
//     try {
//       pcsIndexRes = await axiosInstance.get("/codebookIndex6");
//       dispatch(fetchCodebookDataUpdate({ type: "pcsIndexData", data: decompressData(pcsIndexRes.data) }));
//     } catch (err) {
//       dispatch(fetchCodebookDataError({ type: "pcsIndexData", error: err.message || "Failed to fetch PCS Index" }));
//     }

//     try {
//       pcsTabularRes = await axiosInstance.get("/codebookIndex5");
//       dispatch(fetchCodebookDataUpdate({ type: "pcsTabularData", data: decompressData(pcsTabularRes.data) }));
//     } catch (err) {
//       dispatch(fetchCodebookDataError({ type: "pcsTabularData", error: err.message || "Failed to fetch PCS Tabular" }));
//     }
//     const codebookData12 = {
//       icd10amTabularData: decompressData(icd10amTabularRes?.data),
//       icd10amIndexData: decompressData(icd10amIndexRes?.data),
//       achiIndexData: decompressData(achiIndexRes?.data),
//       achiTabularData: decompressData(achiTabularRes?.data),
//       pcsIndexData: decompressData(pcsIndexRes?.data),
//       pcsTabularData: decompressData(pcsTabularRes?.data),
//     };

//     await saveCodebookToIndexedDB("codebookData12", codebookData12);
//      localStorage.setItem("isFetched12", "true");
//     console.log("[IndexedDB] Saved 'codebookData12' to IndexedDB ✅");

//   }

// );

// export const fetchCodebookData13 = createAsyncThunk(
//   "codebook/fetchData13",
//   async (_, { dispatch }) => {
//     dispatch(fetchCodebookDataPending());
 
//     // Try to load from IndexedDB
//     const cachedData = await getCodebookFromIndexedDB("codebookData13");
//     if (cachedData) {
//       dispatch(fetchCodebookDataUpdate({ type: "icd10amTabularData13", data: cachedData.icd10amTabularData13 }));
//       dispatch(fetchCodebookDataUpdate({ type: "icd10amIndexData13", data: cachedData.icd10amIndexData13 }));
//       dispatch(fetchCodebookDataUpdate({ type: "achiIndexData13", data: cachedData.achiIndexData13 }));
//       dispatch(fetchCodebookDataUpdate({ type: "achiTabularData13", data: cachedData.achiTabularData13 }));

//       //  Set localStorage flag
//       localStorage.setItem("isFetched13", "true");
//       return;
//     }
//     let icd10amTabularRes, icd10amIndexRes, achiIndexRes, achiTabularRes;

//     try {
//       icd10amTabularRes = await axiosInstance.get("/codebook_acs_v13");
//       dispatch(fetchCodebookDataUpdate({ type: "icd10amTabularData13", data: decompressData(icd10amTabularRes.data) }));
//     } catch (err) {
//       dispatch(fetchCodebookDataError({ type: "icd10amTabularData13", error: err.message }));
//     }

//     try {
//       icd10amIndexRes = await axiosInstance.get("/index_codebook_acs_v13");
//       dispatch(fetchCodebookDataUpdate({ type: "icd10amIndexData13", data: decompressData(icd10amIndexRes.data) }));
//     } catch (err) {
//       dispatch(fetchCodebookDataError({ type: "icd10amIndexData13", error: err.message }));
//     }

//     try {
//       achiIndexRes = await axiosInstance.get("/AchiCodebookIndex_v13");
//       dispatch(fetchCodebookDataUpdate({ type: "achiIndexData13", data: decompressData(achiIndexRes.data) }));
//     } catch (err) {
//       dispatch(fetchCodebookDataError({ type: "achiIndexData13", error: err.message }));
//     }

//     try {
//       achiTabularRes = await axiosInstance.get("/achi_codebook_tabular_v13");
//       dispatch(fetchCodebookDataUpdate({ type: "achiTabularData13", data: decompressData(achiTabularRes.data) }));
//     } catch (err) {
//       dispatch(fetchCodebookDataError({ type: "achiTabularData13", error: err.message }));
//     }
//     const codebookData13 = {
//       icd10amTabularData13: decompressData(icd10amTabularRes?.data),
//       icd10amIndexData13: decompressData(icd10amIndexRes?.data),
//       achiIndexData13: decompressData(achiIndexRes?.data),
//       achiTabularData13: decompressData(achiTabularRes?.data),
//     };

//     await saveCodebookToIndexedDB("codebookData13", codebookData13);
//       localStorage.setItem("isFetched13", "true");
//   }
// );

// const codebookSlice = createSlice({
//   name: "codebook",
//   initialState,
//   reducers: {
//     fetchCodebookDataPending: (state) => {
//       state.codeBookLoading = true;
//       state.codeBookError = {};
//       state.completedCalls = 0;
//       //     if (!state.isFetched12 && !state.isFetched13) {
//       //   state.codeBookLoading = true;
//       // }
//     },
//     fetchCodebookDataUpdate: (state, action) => {
//       state[action.payload.type] = action.payload.data;
//       state.completedCalls = (state.completedCalls || 0) + 1;

//       // Mark 12th fetched
//       if (["icd10amTabularData", "icd10amIndexData", "achiIndexData", "achiTabularData", "pcsIndexData", "pcsTabularData"].includes(action.payload.type)) {
//         if (
//           state.icd10amTabularData &&
//           state.icd10amIndexData &&
//           state.achiIndexData &&
//           state.achiTabularData &&
//           state.pcsIndexData &&
//           state.pcsTabularData
//         ) {
//           state.isFetched12 = true;
//         }
//       }
//       // Mark 13th fetched
//       if (["icd10amTabularData13", "icd10amIndexData13", "achiIndexData13", "achiTabularData13"].includes(action.payload.type)) {
//         if (
//           state.icd10amTabularData13 &&
//           state.icd10amIndexData13 &&
//           state.achiIndexData13 &&
//           state.achiTabularData13
//         ) {
//           state.isFetched13 = true;
//         }
//       }

//       if (state.completedCalls >= 4 && state.completedCalls % 4 === 0) {
//         state.codeBookLoading = false;
//       }
//     },
//     fetchCodebookDataError: (state, action) => {
//       state.codeBookError[action.payload.type] = action.payload.error;
//       state.codeBookLoading = false;
//     },
//     updateAcsCode: (state, action) => {
//       state.acsCode = action.payload;
//     },
//     clearAcsCode: (state) => {
//       state.acsCode = "";
//     },
//   },
// });

// export const {
//   fetchCodebookDataPending,
//   fetchCodebookDataUpdate,
//   fetchCodebookDataError,
//   updateAcsCode,
//   clearAcsCode,
// } = codebookSlice.actions;

// export default codebookSlice.reducer;

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../axiosinterceptor";
import pako from "pako";
import { saveCodebookToIndexedDB, getCodebookFromIndexedDB } from "../../../utils/indexedDB";
 const codebookdevEnv = process.env.REACT_APP_FLAG_DEV;

// --- Helper to decompress
const decompressData = (data) => {
  if (data?.body) {
    try {
      const decompressedBody = pako.ungzip(
        Uint8Array.from(atob(data.body), (c) => c.charCodeAt(0)),
        { to: "string" }
      );
      return JSON.parse(decompressedBody);
    } catch (error) {
      console.error("Error decompressing data:", error);
      return null;
    }
  }
  return null;
};

// --- Initial Redux State
const initialState = {
  icd10amTabularData: [],
  icd10amIndexData: [],
  achiIndexData: [],
  achiTabularData: [],
  pcsIndexData: [],
  pcsTabularData: [],
  icd10amTabularData13: [],
  icd10amIndexData13: [],
  achiIndexData13: [],
  achiTabularData13: [],
  codeBookLoading: false,
  codeBookError: {},
  acsCode: "",
  isFetched12: false,
  isFetched13: false,
  activeTab:  codebookdevEnv ? "ICD 10 AM Index" : "ICD 10 CM Index",
  activeIcon: "ICD",
  rawSearchQuery: "",
  searchQuery:"",
  searchByCodeId:null,
  onChangeCodeBook : false
};

// --- Async Thunk for 12th Edition
export const fetchCodebookData = createAsyncThunk(
  "codebook/fetchData12",
  async (_, { dispatch }) => {
    dispatch(fetchCodebookDataPending());

    const cachedData = await getCodebookFromIndexedDB("codebookData12");
    if (cachedData) {

      Object.entries(cachedData).forEach(([key, data]) => {
        dispatch(fetchCodebookDataUpdate({ type: key, data }));
      });

      localStorage.setItem("isFetched12", "true");
      return;
    }

    const isUSA = process.env.REACT_APP_FLAG_USA ;

    let responses = {};
    try {
      responses.icd10amTabularData = decompressData((await axiosInstance.get("/codebook_acs")).data);
      responses.icd10amIndexData = decompressData((await axiosInstance.get("/index_codebook_acs")).data);
      responses.achiIndexData = decompressData((await axiosInstance.get("/AchiCodebookIndex")).data);
      responses.achiTabularData = decompressData((await axiosInstance.get("/achi_codebook_tabular")).data);
     // Only fetch these 2 for USA
      if (isUSA) {
        responses.pcsTabularData = decompressData((await axiosInstance.get("/codebookIndex5")).data);
        responses.pcsIndexData = decompressData((await axiosInstance.get("/codebookIndex6")).data);
      }

      Object.entries(responses).forEach(([key, data]) => {
        dispatch(fetchCodebookDataUpdate({ type: key, data }));
      });

      await saveCodebookToIndexedDB("codebookData12", responses);
      localStorage.setItem("isFetched12", "true");
    } catch (err) {
      console.error("API fetch error:", err);
      Object.keys(responses).forEach((key) => {
        dispatch(fetchCodebookDataError({ type: key, error: err.message }));
      });
    }
  }
);

// --- Async Thunk for 13th Edition
export const fetchCodebookData13 = createAsyncThunk(
  "codebook/fetchData13",
  async (_, { dispatch }) => {
    
    dispatch(fetchCodebookDataPending());

    const cachedData = await getCodebookFromIndexedDB("codebookData13");
    if (cachedData) {

      Object.entries(cachedData).forEach(([key, data]) => {
        dispatch(fetchCodebookDataUpdate({ type: key, data }));
      });

      localStorage.setItem("isFetched13", "true");
      return;
    }


    let responses = {};
    try {
      responses.icd10amTabularData13 = decompressData((await axiosInstance.get("/codebook_acs_v13")).data);
      responses.icd10amIndexData13 = decompressData((await axiosInstance.get("/index_codebook_acs_v13")).data);
      responses.achiIndexData13 = decompressData((await axiosInstance.get("/AchiCodebookIndex_v13")).data);
      responses.achiTabularData13 = decompressData((await axiosInstance.get("/achi_codebook_tabular_v13")).data);

      Object.entries(responses).forEach(([key, data]) => {
        dispatch(fetchCodebookDataUpdate({ type: key, data }));
      });

      await saveCodebookToIndexedDB("codebookData13", responses);
      localStorage.setItem("isFetched13", "true");
    } catch (err) {
      console.error(" API fetch error:", err);
      Object.keys(responses).forEach((key) => {
        dispatch(fetchCodebookDataError({ type: key, error: err.message }));
      });
    }
  }
);

// --- Slice
const codebookSlice = createSlice({
  name: "codebook",
  initialState,
  reducers: {
    fetchCodebookDataPending: (state) => {
      state.codeBookLoading = true;
      state.codeBookError = {};
    },
    fetchCodebookDataUpdate: (state, action) => {
      state[action.payload.type] = action.payload.data;
      const { type } = action.payload;

      // 12th edition complete
      if (
        ["icd10amTabularData", "icd10amIndexData", "achiIndexData", "achiTabularData", "pcsIndexData", "pcsTabularData"].includes(type)
      ) {
        const { icd10amTabularData, icd10amIndexData, achiIndexData, achiTabularData, pcsIndexData, pcsTabularData } = state;
        if (icd10amTabularData && icd10amIndexData && achiIndexData && achiTabularData && pcsIndexData && pcsTabularData) {
          state.isFetched12 = true;
        }
      }

      // 13th edition complete
      if (
        ["icd10amTabularData13", "icd10amIndexData13", "achiIndexData13", "achiTabularData13"].includes(type)
      ) {
        const { icd10amTabularData13, icd10amIndexData13, achiIndexData13, achiTabularData13 } = state;
        if (icd10amTabularData13 && icd10amIndexData13 && achiIndexData13 && achiTabularData13) {
          state.isFetched13 = true;
        }
      }

      state.codeBookLoading = false;
    },
    fetchCodebookDataError: (state, action) => {
      state.codeBookError[action.payload.type] = action.payload.error;
      state.codeBookLoading = false;
    },
     setActiveTab: (state, action ) => {
      state.activeTab = action.payload
    },
    setActiveIcon: (state, action ) => {
      state.activeIcon = action.payload
    },
    setRawSearchQuery: (state, action ) => {
      state.rawSearchQuery = action.payload
    },
    setSearchQuery:(state,action) =>{
      state.searchQuery = action.payload
    },
    setSearchByCodeId:(state,action) =>{
      state.searchByCodeId = action.payload
    },
    updateAcsCode: (state, action) => {
      state.acsCode = action.payload;
    },
    setOnChangeCodeBook: (state, action) => {
  state.onChangeCodeBook = action.payload;
},

    //  handleResetSearch: (state) => {
    //   state.searchByCodeId = null;
    //   state.rawSearchQuery = "";
    // },
 // In your slice or action file
handleResetSearch: (state, action) => {
  const payload = action.payload;
  
  if (payload?.id) {
    state.searchByCodeId = payload.id;
    state.rawSearchQuery = payload.rawSearchQuery || "";
  } else if (payload?.rawSearchQuery) { 
    state.rawSearchQuery = payload.rawSearchQuery;
    state.searchByCodeId = null;
  } else {
    state.searchByCodeId = null;
    state.rawSearchQuery = "";
  }
},

    clearAcsCode: (state) => {
      state.acsCode = "";
    },
  },
});

export const {
  fetchCodebookDataPending,
  fetchCodebookDataUpdate,
  fetchCodebookDataError,
  updateAcsCode,
  clearAcsCode,
   setActiveTab, 
  setActiveIcon,
  setRawSearchQuery,
  setSearchByCodeId,
  handleResetSearch,
  setOnChangeCodeBook
} = codebookSlice.actions;

export default codebookSlice.reducer;
